// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2wgZE","inner":"Form_inner__1xDaT","range":"Form_range__3g3RU","name":"Form_name__3IzWF","actions":"Form_actions__1BI5O"};